import { render, staticRenderFns } from "./SAPPortalStatusMatrix.vue?vue&type=template&id=689e983e&scoped=true"
import script from "./SAPPortalStatusMatrix.vue?vue&type=script&lang=js"
export * from "./SAPPortalStatusMatrix.vue?vue&type=script&lang=js"
import style0 from "./SAPPortalStatusMatrix.vue?vue&type=style&index=0&id=689e983e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e983e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689e983e')) {
      api.createRecord('689e983e', component.options)
    } else {
      api.reload('689e983e', component.options)
    }
    module.hot.accept("./SAPPortalStatusMatrix.vue?vue&type=template&id=689e983e&scoped=true", function () {
      api.rerender('689e983e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAPPortalStatusMatrix.vue"
export default component.exports